import {
  CheckMetadata,
  CheckMetadataItemType,
  TableCheckMetadataItem,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { IdExperimentalModelDetection } from 'dashboard/models/check';

export const computeIdExperimentalModelDetectionMetadata = (
  check: IdExperimentalModelDetection,
): CheckMetadata => {
  const matchedModels = check?.metadata?.['matched-models'] ?? [];

  const metadata = [
    {
      type: CheckMetadataItemType.Table,
      heading: { title: 'Matched models' },
      rowHeaders: ['Model code', 'Version code', 'Risk level'],
      rows: matchedModels.map((match: any) => [
        match['model-code'],
        match['version-code'],
        RiskLevelSticker({ riskLevel: match['risk-level'] }),
      ]),
    } as TableCheckMetadataItem,
  ];

  return {
    metadata: metadata,
    hideIfVerificationPassed: false,
  };
};
